import React from 'react'
import { IconButton } from 'shared/ui/IconButton/ui/IconButton'
import type { ITooltipProps } from 'shared/ui'
import type { ZIndex } from 'shared/constants/zIndex'
import styles from '../styles.module.scss'

type IIconClearButtonProps = {
  onClear?: () => void
  showTooltip?: boolean
  zIndex?: ZIndex
}

export const IconClearButton: React.FC<IIconClearButtonProps> = ({
  onClear,
  showTooltip = false,
  zIndex,
}) => {
  const tooltipProps: ITooltipProps = {
    label: 'Remove',
    placement: 'top',
    disableInteractive: true,
    zIndex,
  }

  return (
    <div className={styles.rightIcon}>
      <IconButton
        icon={'close'}
        variant={'icon'}
        color={'secondary'}
        size={'small'}
        fontSize={16}
        onClick={onClear}
        tooltipProps={showTooltip ? tooltipProps : undefined}
        ariaLabel='IconClearButton'
      />
    </div>
  )
}
